import styled from 'styled-components';
import withColor from 'util/hoc/with-color';
import Dropdown from 'library/components/form-components/dropdown';
import {
  StyledFilterDropdownOption,
  StyledStar,
} from 'apps/journey/pages/career-exploration/components/filters/styled-filter-types';

export const StyledFilterDropdown = styled(Dropdown)`
  max-width: 150px;
  width: auto;
  padding: 0 1em;
  max-height: 2em;
  text-align: center;
  margin-right: 0.5em;
  border-radius: 18px;
  border: 1px solid #D7D7D7;
  ${(props) =>
    props.filterActive
      ? `border-color: #F0BD1D;
     background-color: #FCF1D1;`
      : ''}
  
  .${(props) => props.contentClassName} {
    border-radius: 16px;
    padding-bottom: 1em;
    ${(props) => !props.description && 'padding-top: 1em;'}
    border: 1px solid #F0BD1D;
    background: white;
    flex-direction: column;
    position: absolute;
    z-index: 1;
    top: 2.5em;
    width: auto;
    left: 0;
    overflow-y: auto;
    max-height: 800px;
    box-shadow: 1px 4px 10px 0 rgba(0, 0, 0, 0.1),
    1px 6px 10px 0 rgba(0, 0, 0, 0.12);
  }
  
  span {
    vertical-align: middle;
    ${(props) => (props.filterActive ? 'color: #594302;' : '')}
  }
  
  &:hover,
  &:focus {
    border-color: #F0BD1D;
    box-shadow: 1px 4px 10px 0 rgba(0,0,0,0.1), 1px 6px 10px 0 rgba(0,0,0,0.12);
    span:first-child {
      color: #594302;
    }
  }
`;

export const StyledFilterMobileContainer = withColor(styled.div`
  width: 100%;
  padding-bottom: 1em;
  margin: 0.5em 0 0.5em;
  border-bottom: 1px solid ${(props) => props.theme.colors.grey200};
`);

export const StyledMobileFilterRow = styled.div`
  padding: 0 2em;
  ${StyledFilterDropdownOption}, ${StyledStar} {
    margin-left: 0;
    padding-left: 0;
  }

  ${StyledFilterDropdownOption} div {
    margin-left: 0;
  }
`;

export const StyledFilterDescription = withColor(styled.label`
  width: 100%;
  min-width: 200px;
  color: ${(props) => props.theme.colors.grey800};
  font-weight: bold;
  text-align: left;
  font-size: 14px;

  @media (min-width: ${(props) => props.theme.screen.tablet}px) {
    color: ${(props) => props.theme.colors.yellow700};
  }
`);
